import { useRef, useState } from "react";
import Image from "next/image";
import styles from "@/components/CustomComponents/ShowroomLocations/index.module.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { renderRichText } from "@/utils/formatters";

export default function ShowroomLocations({ customCarouselBannerData }) {
  const { title, showroomList } = customCarouselBannerData;
  const sliderRef = useRef(null);
  const settings = {
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: current => setActiveIndex(current),
  };

  const handleCardClick = index => {
    setActiveIndex(index);
    sliderRef.current?.slickGoTo(index);
  };

  const [activeIndex, setActiveIndex] = useState(0);

  const buttonNav = (e, url) => {
    e.stopPropagation;
    window.open(url, "_blank");
  };

  return (
    <div className={styles.wrapper}>
      <div className="mx-auto px-4">
        <h3 className="font-bold koh-location-title">{title}</h3>
        <div className="grid gap-8 grid-cols-1 lg:grid-cols-12">
          <div className="col-span-1 lg:col-span-8 order-1 lg:order-2">
            <Slider ref={sliderRef} {...settings}>
              {showroomList.map((location, index) => (
                <div key={index}>
                  <div className="relative h-[350px] overflow-hidden rounded-xl md:h-[500px]">
                    <Image
                      src={location?.fields?.imageUrl}
                      alt={location?.fields?.name}
                      fill
                      className="object-cover"
                      sizes="(max-width:768px) 100vw, 70vw"
                    />
                  </div>
                </div>
              ))}
            </Slider>
          </div>

          <div
            className=" 
                      grid
                      grid-flow-col
                      auto-cols-[95%]
                      gap-4
                      overflow-x-auto
                      px-2
                      py-2
                      md:block
                      md:space-y-4 col-span-1 lg:col-span-4 order-2 lg:order-1 "
          >
            {showroomList.map((location, index) => {
              const { description, name, ctas } = location?.fields;
              const address = renderRichText(description) || "";
              const { label, mediaUrl = "" } = ctas?.[0]?.fields;
              return (
                <div
                  key={index}
                  onClick={() => handleCardClick(index)}
                  className={` w-full lg:mb-4 cursor-pointer rounded-xl p-5 transition-all duration-300 w-full overflow-x-auto md:overflow-hidden
                  ${
                    activeIndex === index
                      ? "active-part bg-neutral-50 shadow-lg shadow-[0_0_10px_0_#000,0_0_10px_0_#000]"
                      : "border border-neutral-200 hover:shadow-md inactive-part"
                  }`}
                >
                  <p className="text-lg font-semibold slider-title  !font-[helveticaBold,_Helvetica,_sans-serif] text-[18px]">
                    {name}
                  </p>

                  <p className="mt-3 text-sm text-neutral-500 !font-[helveticaRoman,_Helvetica,_sans-serif] text-[14px] text-[#333]">
                    {address}
                  </p>

                  <button
                    onClick={e => buttonNav(e, mediaUrl)}
                    className="mt-4 flex h-12 w-full items-center !font-[NotoSansRegular,_Helvetica,_sans-serif]  justify-center border border-[#d2d2d2]"
                  >
                    {label}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
